// extracted by mini-css-extract-plugin
export default {"notFoundPage":"NotFound_notFoundPage__EH7XG"};